import type { FC } from 'react';
import { Popover, IconButton } from '@radix-ui/themes';
import classNames from 'classnames';

const MembershipLabel: FC<{
  premiumMember?: boolean;
  premiumClubMember?: boolean;
  hidden?: boolean;
}> = ({ premiumMember = false, premiumClubMember = false, hidden = false }) => {
  const basicMember = (
    <IconButton
      radius='full'
      className={classNames('hover:bg-accent-accent-6', { invisible: hidden })}
      aria-label='Utente Tennistalker'
    >
      <img src='/images/icons/tt-logo.svg' alt='Logo utente Tennistalker' height='18' className='p-1' />
    </IconButton>
  );
  const trialMember = (
    <IconButton radius='full' className='bg-black' aria-label='Utente Tennistalker Membership'>
      <img src='/images/icons/tt-logo-y.svg' className='p-1' alt='Logo Tennistalker Membership' height='18' />
    </IconButton>
  );
  const clubMember = (
    <IconButton radius='full' aria-label='Utente Tennistalker Club Membership'>
      <img src='/images/icons/tt-club-membership-logo.svg' alt='Logo Tennistalker Club Membership' height='18' />
    </IconButton>
  );
  const getLabel = () => {
    if (premiumClubMember) {
      return clubMember;
    } else if (premiumMember) {
      return trialMember;
    } else {
      return basicMember;
    }
  };

  return (
    <Popover.Root>
      <Popover.Trigger>{getLabel()}</Popover.Trigger>
      <Popover.Content maxWidth='300px' className='bg-neutral-neutral-11'>
        <div className='text-accent-accent-6 text-xs'>
          {premiumMember || premiumClubMember ? 'Profilo verificato - Club Member!' : 'Profilo verificato'}
        </div>
      </Popover.Content>
    </Popover.Root>
  );
};

export default MembershipLabel;
